import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";
import "../../styles/events.css";

const EventQuick = () => {
  const dispatch = useDispatch();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  const { upcomingData, pastData, isLoadingUpcoming, isLoadingPast } = useSelector((state) => ({
    upcomingData: state.apiData?.data?.eventsUpcoming,
    pastData: state.apiData?.data?.eventsPast,
    isLoadingUpcoming: state.apiData?.loading?.eventsUpcoming,
    isLoadingPast: state.apiData?.loading?.eventsPast
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: 'event/upcoming?limit=3', itemKey: 'eventsUpcoming' }));
    dispatch(fetchApiData({ url: 'event/past?limit=3', itemKey: 'eventsPast' }));
  }, [dispatch]);

  useEffect(() => {
    if (upcomingData?.data) {
      setUpcomingEvents(upcomingData.data.slice(0, 3));
    }
  }, [upcomingData]);

  useEffect(() => {
    if (pastData?.data) {
      setPastEvents(pastData.data.slice(0, 3));
    }
  }, [pastData]);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const formatTime = (time) => {
    return time ? time.slice(0, 5) : '';
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  if (isLoadingUpcoming && isLoadingPast) {
    return <p className="loading">Chargement des événements...</p>;
  }

  return (
    <div className="events-quick-container">
      {/* Événements à venir */}
      <div className="events-card">
        <h3 className="events-header">
          <i className="pi pi-calendar-plus"></i> Événements à Venir
        </h3>
        {upcomingEvents.length > 0 ? (
          upcomingEvents.map((event) => (
            <div key={event.id} className="event-item">
              <div className="event-item-header">
                <h4 className="event-item-title">{event.title}</h4>
                {event.category && (
                  <span className="event-category">{event.category}</span>
                )}
              </div>
              <p className="event-item-description">
                {truncateText(event.description)}
              </p>
              <div className="event-item-details">
                <span className="event-date">
                  <i className="pi pi-calendar"></i> {formatDate(event.date)}
                </span>
                {event.time && (
                  <span className="event-time">
                    <i className="pi pi-clock"></i> {formatTime(event.time)}
                  </span>
                )}
                {event.location && (
                  <span className="event-location">
                    <i className="pi pi-map-marker"></i> {event.location}
                  </span>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="no-events">Aucun événement à venir</p>
        )}
        <Link to="/evenements" className="see-more">
          Voir tous les événements
        </Link>
      </div>

      {/* Événements passés */}
      <div className="events-card past-events">
        <h3 className="events-header past">
          <i className="pi pi-history"></i> Événements Passés
        </h3>
        {pastEvents.length > 0 ? (
          pastEvents.map((event) => (
            <div key={event.id} className="event-item">
              <div className="event-item-header">
                <h4 className="event-item-title">{event.title}</h4>
                {event.category && (
                  <span className="event-category past">{event.category}</span>
                )}
              </div>
              <p className="event-item-description">
                {truncateText(event.description)}
              </p>
              <div className="event-item-details">
                <span className="event-date">
                  <i className="pi pi-calendar"></i> {formatDate(event.date)}
                </span>
                {event.time && (
                  <span className="event-time">
                    <i className="pi pi-clock"></i> {formatTime(event.time)}
                  </span>
                )}
                {event.location && (
                  <span className="event-location">
                    <i className="pi pi-map-marker"></i> {event.location}
                  </span>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="no-events">Aucun événement passé</p>
        )}
      </div>
    </div>
  );
};

export default EventQuick;